// rxjs-extension/reactives/toggle.ts
import { BehaviorSubject } from "rxjs";
var ToggleBehaviorSubject = class extends BehaviorSubject {
  constructor(defaultValue = false) {
    super(defaultValue);
  }
  toggle() {
    this.next(!this.getValue());
  }
  turnOn() {
    this.next(true);
  }
  turnOff() {
    this.next(false);
  }
};
export {
  ToggleBehaviorSubject
};
